<template>
  <component :is="component" />
</template>

<script>
import makePlanOrderCheck from '../components/makePlanOrderCheck.vue'
import makePlanOrder from '../makePlanOrder.vue'
export default {
  components: {
    makePlanOrderCheck,
    makePlanOrder
  },
  data() {
    return {
      component: 'makePlanOrderCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'makePlanOrderCheck' : 'makePlanOrder'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/check/makePlanOrderCheck.vue